import { forwardRef } from 'react'
import clsx from 'clsx'

const Input = forwardRef(({ 
  label, 
  error, 
  icon: Icon,
  className,
  ...props 
}, ref) => {
  return (
    <div className="space-y-2">
      {label && (
        <label className="block text-sm font-medium text-white/90">
          {label}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-white/50">
            <Icon className="w-5 h-5" />
          </div>
        )}
        <input
          ref={ref}
          className={clsx(
            'glass-input w-full',
            Icon && 'pl-12',
            error && 'border-red-500/50 focus:ring-red-500/50',
            className
          )}
          {...props}
        />
      </div>
      {error && (
        <p className="text-sm text-red-400">
          {error}
        </p>
      )}
    </div>
  )
})

Input.displayName = 'Input'

export default Input

